<template>
  <b-col cols="12"
         class="d-md-none mb-2"
  >
    <div class="box">
      <b-row class="mb-2">
        <b-col cols="12"
               class="font-condensed mb-2"
        >
          {{ item.title }}
        </b-col>
        <b-col cols="12">
          {{ item.short_description }}
        </b-col>
      </b-row>

      <b-row align-v="center" class="mb-2">
        <b-col cols="auto"
               class="font-condensed pr-0"
        >
          Rank
        </b-col>
        <b-col cols="5">
          <b-progress height=".5rem"
                      variant="success"
                      :value="item.scoreValue"
          />
        </b-col>
      </b-row>

      <b-row align-v="center">
        <b-col cols="6"
               class="font-condensed"
        >
          <b-btn size="sm"
                 variant="primary"
                 class="font-condensed"
                 @click.prevent="$emit('sessionStart', item)"
          >
            Start session
          </b-btn>
        </b-col>
        <b-col cols="6" class="text-right">
          <b-btn size="sm"
                 variant="primary"
                 class="font-condensed"
                 @click.prevent="$emit('sessionDetails', item)"
          >
            <b-icon :icon="['fal', 'plus']" />
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
